import { LexicalComposer } from '@lexical/react/LexicalComposer'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { ContentEditable } from '@lexical/react/LexicalContentEditable'
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary'
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin'
import { useEffect } from 'react'
import { LEXICAL_DEFAULT_CONFIG } from './conf'

type ViewProps = {
  content: any // eslint-disable-line @typescript-eslint/no-explicit-any
}

function ContentUpdater({ content }: ViewProps) {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    editor.update(() => {
      try {
        const newState = editor.parseEditorState(content)
        editor.setEditorState(newState)
      } catch (e) {
        console.error('Failed to parse editor state', e)
      }
    })
  }, [content, editor])

  return null
}

export default function Viewer({ content }: ViewProps) {
  return (
    <LexicalComposer
      initialConfig={{
        ...LEXICAL_DEFAULT_CONFIG,
        namespace: 'viewer',
        editorState: (editor) => {
          try {
            const parsed = editor.parseEditorState(content)
            editor.setEditorState(parsed)
          } catch (e) {
            console.error('Failed to parse editor state', e)
          }
        },
        editable: false,
      }}
    >
      <ContentUpdater content={content} />
      <RichTextPlugin
        contentEditable={<ContentEditable />}
        placeholder={null}
        ErrorBoundary={LexicalErrorBoundary}
      />
    </LexicalComposer>
  )
}
